import React from "react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from "../../../../common/StyledSelect";
import ErrorIcon from "@material-ui/icons/Error";
import Cancel from "@material-ui/icons/Cancel";
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import formStyles from "../../formStyles";
class UserUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addNewUserInProgress: false,
            errorMessage: null,
            userInfo: this.props.userInfo || this.getDefaultUserInfo(),
            errorInfo: {},
            updatingUserInProgress: false,
            isPasswordUserCreationFlow:  props.isPasswordUserCreationFlow
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.userInfo !== prevProps.userInfo){
            this.setState({
                userInfo: this.props.userInfo || this.getDefaultUserInfo(),
                errorInfo: {},
                errorMessage: null
            });
        } else if(this.props.error !== prevProps.error){
            this.setState({
                errorMessage: this.props.error
            });
        }
    }

    getDefaultUserInfo(){
        return ({
            userName: "",
            firstName: "",
            lastName: "",
            email: "",
            jobTitle:"",
            defaultTerminal: null,
            otherTerminals: null,
            roles: null,
            isLocked: null,
        });
    }

    // Update userInfo based on inputs
    handleChange = name => value => {
        if(name === "defaultTerminal"){
            value = value && value.label;
        } else if(name === "otherTerminals"){
            value = value && value.map(x => x.label).join(",");
        } else if(name === "roles"){
            value = value && value.map(x => x.label).join(",");
        }
        this.setState(state => ({
            userInfo: {
                ...state.userInfo,
                [name]: value
            },
            errorInfo: {
                ...state.errorInfo,
                [name]: this.getFieldError(name, value)
            },
            errorMessage: null
        }));
    }

    // Clear user value in the field
    clearField = field => event => {
        this.handleChange(field)("");
    }

    // Email valitdation regex
    isValidEmail = (email) => {
        const regex = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        return regex.test(email);
    }

    // Checks for errors for each field
    getFieldError = (field, value) => {
        switch (field) {
            case "firstName":
                return this.state.isPasswordUserCreationFlow ? value && value.trim() ? null : "* First name is required" : null;
            case "lastName":
                return this.state.isPasswordUserCreationFlow ? value && value.trim() ? null : "* Last name is required" : null;
            case "defaultTerminal":
                return value
                  ? null
                  : `* Default ${this.props.terminalAccessLabel.fullName} is required`;
            case "roles":
                return value ? null : "* Role is required";
            case "email":
                if (!(value && value.trim())) {
                    return "* Email is required"
                } else if (!this.isValidEmail(value.trim())) {
                    return "A valid email is required"
                }
                return null;
            default:
                return null;
        }
    }

    // Set Error messages for each field
    getErrorInfo = () => {
        let errorInfo = {};
        Object.keys(this.state.userInfo).forEach(fieldName => {
            errorInfo[fieldName] = this.getFieldError(fieldName, this.state.userInfo[fieldName]);
        });
        this.setState({
            errorInfo
        });
        return errorInfo;
    }

    // Calls add/update user api if no errors else show error messages
    createUser = () => {
        const errorInfo  = this.getErrorInfo();
        const error = Object.values(errorInfo).filter(value => value).length;
        if (!error) {
            if(this.props.onCreateOrUpdateUser){
                this.props.onCreateOrUpdateUser({...this.state.userInfo});
            }
        }
    }

    // Display clear and error Icons based on the input
    getFieldIcon = field =>{
        const { classes } = this.props;
        if(this.state.userInfo[field]){
            return <InputAdornment ><Cancel  onClick={this.clearField(field)} classes={{root: classes.iconClass}}/></InputAdornment>
        } else if(this.state.errorInfo[field]){
            return <InputAdornment><ErrorIcon color="error" /></InputAdornment>
        }
        return null;
    }

    // get common props for all the text fields
    getTextFieldDefaultProps = (fieldName, classes) => {
        return {
                id: fieldName,
                autoComplete:"off",
                classes:{
                    root: classes.fieldRoot
                },
                InputLabelProps:{
                    classes:{
                        root: classes.label
                    }
                },
                InputProps :{
                    classes:{
                        root: classes.inputRoot,
                        input: classes.inputField,
                        notchedOutline: classes.notchedOutline,
                        focused: classes.inputFocused,
                        disabled:classes.inputDisabled,
                        error: classes.inputError
                    },
                    endAdornment: this.getFieldIcon(fieldName)
                },
                value :this.state.userInfo[fieldName],
                onChange : (event) => this.handleChange(fieldName)(event && event.target ? event.target.value : ""),
                margin : "normal",
                variant : "outlined",
                error : Boolean(this.state.errorInfo[fieldName]),
                helperText : this.state.errorInfo[fieldName]
            }
    }

    render() {
        const { classes } = this.props;
        const { userInfo, errorInfo, isPasswordUserCreationFlow } = this.state;
        const createNewUser = !Boolean(userInfo.userId);
        return (
           <div>
                    <h4 className={classes.title}>{createNewUser ? "Create User" : "Update User" }</h4>
                    <form className={classes.form} noValidate>
                      {isPasswordUserCreationFlow && createNewUser &&  <><div className={classes.flexRow}>
                            <TextField
                                {...this.getTextFieldDefaultProps("firstName", classes)}
                                label = "First Name"
                                value = {userInfo.firstName || ""}
                                autoFocus
                            />
                        </div>
                         <div className={classes.flexRow}>
                             <TextField
                                {...this.getTextFieldDefaultProps("lastName", classes)}
                                label = "Last Name"
                                value = {userInfo.lastName || ""}
                            />
                        </div></>}
                        <div className={classes.flexRow}>
                            <TextField
                                {...this.getTextFieldDefaultProps("email", classes)}
                                label = "Email"
                                type = "email"
                                value ={userInfo.email || ""}
                            />
                        </div>
                        <div className = {classes.flexRow} >
                            <Select
                                textFieldProps= {{
                                    id: "roles",
                                    label: "Roles",
                                    variant: "outlined",
                                    helperText : errorInfo.roles
                                }}
                                value={userInfo.roles && userInfo.roles.split(",")}
                                error ={Boolean(errorInfo.roles)}
                                isMulti = {true}
                                onChange ={this.handleChange('roles')}
                                data={this.props.availableRoles}
                            />
                        </div>
                        <div className = {classes.flexRow} >
                            <Select
                                textFieldProps= {{
                                    id: "defaultTerminal",
                                    label: `Default ${this.props.terminalAccessLabel.shortName}`,
                                    variant: "outlined",
                                    helperText : errorInfo.defaultTerminal
                                }}
                                value={userInfo.defaultTerminal}
                                error ={Boolean(errorInfo.defaultTerminal)}
                                onChange={this.handleChange('defaultTerminal')}
                                data={this.props.terminalList}
                                print={true}
                            />
                        </div>
                        <div className = {classes.flexRow} >
                            <Select
                                textFieldProps= {{
                                    id: "otherTerminals",
                                    label: `Other ${this.props.terminalAccessLabel.shortName}s`,
                                    variant: "outlined",
                                }}
                                value ={userInfo.otherTerminals && userInfo.otherTerminals.split(",")}
                                isMulti = {true}
                                onChange ={this.handleChange('otherTerminals')}
                                data={this.props.terminalList && this.props.terminalList.filter(option => option.label !== userInfo.defaultTerminal)} // remove default terminal from selectable option
                            />
                        </div>
                    </form>
                    <div className={classes.actionContainer}>
                        <Button variant="outlined" color="primary"  size="medium" onClick={this.props.onClose} classes={{root: classes.actionButton}} id="closeButton">
                                Close
                        </Button>
                        <Button variant="contained" color="primary" size="medium" type="submit" onClick={this.createUser} disabled={this.props.userUpdateInProgress} classes={{root: classes.actionButton, disabled: classes.actionButtonDisabled}} id={createNewUser ? "AddUser" : "UpdateUser"}>
                             { this.props.userUpdateInProgress ? <CircularProgress  size={16} classes={{root: classes.circularProgress}} /> :  createNewUser ? "Add User" : "Update User" }
                        </Button>
                    </div>
                    { this.state.errorMessage &&
                        <div className={classes.errorMessage}>{this.state.errorMessage}</div>
                    }
        </div>
        )
    }
}

export default compose(withStyles(formStyles),withSnackbar)(UserUpdate);